export default {"src":"/_next/static/media/saurashtra-league.c58218ce.svg","height":174,"width":187,"blurWidth":0,"blurHeight":0};